class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.bindHoverEvents();
  }

  bindHoverEvents() {
    this.addEventListener('mouseenter', () => {
      if (!window.matchMedia('(hover: hover) and (min-width: 1200px)').matches) return;
      clearTimeout(this._closeTimer);
      this.openMenu();
    });
    this.addEventListener('mouseleave', () => {
      if (!window.matchMedia('(hover: hover) and (min-width: 1200px)').matches) return;
      this._closeTimer = setTimeout(() => this.close(), 200);
    });
  }

  bindSubmenuHoverEvents(submenu) {
    submenu.addEventListener('mouseenter', () => {
      clearTimeout(this._closeTimer);
    });
    submenu.addEventListener('mouseleave', () => {
      this._closeTimer = setTimeout(() => this.close(), 200);
    });
  }

  openMenu() {
    if (this.mainDetailsToggle.hasAttribute('open')) return;
    this.mainDetailsToggle.setAttribute('open', '');
    const summary = this.mainDetailsToggle.querySelector('summary');
    summary.setAttribute('aria-expanded', true);
    // Align dropdown center to button center for fixed positioning
    const submenu = this.mainDetailsToggle.querySelector('.header__submenu');
    if (submenu && window.matchMedia('(min-width: 1200px)').matches) {
      const rect = summary.getBoundingClientRect();
      submenu.style.left = `${rect.left + rect.width / 2}px`;
      if (!submenu._hoverBound) {
        this.bindSubmenuHoverEvents(submenu);
        submenu._hoverBound = true;
      }
    }
    this.onToggle();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
